import { GET_API_TOKEN, API_BASE_URL } from '../../constants/apiConstants'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { MewsScoresResponse } from './types'
const baseUrl = API_BASE_URL
const baseQuery = fetchBaseQuery({
  baseUrl: `${baseUrl}/api/rpmweb`,
  prepareHeaders(headers, api) {
    let token = () => GET_API_TOKEN()
    headers.set('Authorization', `Bearer ${token()}`)
  },
})

export const PatientAdmissionsMewsScoreApi = createApi({
  reducerPath: 'patientAdmissionsMewsScoreApi',
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getPatientAdmissionsMewsScoreData: builder.query<MewsScoresResponse, {}>({
      query: () => 'sensors/admissions',
    }),
  }),
})

export const { useGetPatientAdmissionsMewsScoreDataQuery } =
  PatientAdmissionsMewsScoreApi
